// https://github.com/visionmedia/superagent
import Request from 'superagent';

const headers = {
  XRequestedWith: 'X-Requested-With',
  XMLHttpRequest: 'XMLHttpRequest',
};

export function bustCache(url) {
  return `${url + (url.indexOf('?') > -1 ? '&' : '?')}bustcache=${Math.random()}`;
}

// get(url, fn);
// get(url, data, fn);
export function get(url, data, fn) {
  if (typeof data === 'function') {
    fn = data;
    data = undefined;
  }

  let req = Request.get(url)
    .set(headers.XRequestedWith, headers.XMLHttpRequest);

  if (data) {
    req = req.query(data);
  }

  return req.end(fn);
}

export function getWithoutCache(url, fn) {
  return get(bustCache(url), fn);
}

export function post(url, data, fn) {
  return Request.post(url)
    .set(headers.XRequestedWith, headers.XMLHttpRequest)
    .send(data)
    .end(fn);
}
